import { SPALink } from '@hh.ru/redux-spa-middleware';
import Button, { ButtonScale } from 'bloko/blocks/button';
import NotificationHeading from 'bloko/blocks/notificationManager/NotificationHeading';
import VSpacing from 'bloko/blocks/vSpacing';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';
import { formatNewLine } from 'bloko/common/trl';

import translation from 'src/components/translation';
import {
    ChangeTopicActionError as Error,
    isChangeTopicActionError,
} from 'src/models/employerNegotiationsChangeTopic/error.types';

const TrlKeys = {
    [Error.ManagerLimit]: 'negotiations.changeTopic.errors.MANAGER_LIMIT_EXCEED',
    [Error.EmployerLimit]: 'negotiations.changeTopic.errors.EMPLOYER_LIMIT_EXCEED',
    [Error.ArchiveTopic]: 'negotiations.changeTopic.errors.CANT_CHANGE_ARCHIVE_TOPIC_STATE',
    [Error.ReadOnlyTopic]: 'negotiations.changeTopic.errors.CANT_CHANGE_READ_ONLY_TOPIC',
    [Error.InvitationLimit]: 'negotiations.changeTopic.errors.INVITATION_LIMIT_EXCEEDED',
    [Error.CantInvite]: 'negotiations.changeTopic.errors.VACANCY_CANT_INVITE_TO',
    [Error.ResumesUnavailable]: 'negotiations.changeTopic.errors.RESUMES_UNAVAILABLE',
    [Error.VacancyUnavailable]: 'negotiations.changeTopic.errors.VACANCY_UNAVAILABLE',
    [Error.NoFaService]: 'changeTopic.errors.NO_FA_SERVICE',
    [Error.FunnelStageNotFound]: 'negotiations.changeTopic.errors.notification.funnelStageNotFound',
    [Error.FunnelByVacancyLocked]: 'negotiations.changeTopic.errors.notification.funnelByVacancyLocked',
    [Error.AddressUnavailable]: 'negotiations.changeTopic.errors.notification.addressUnavailable',
    [Error.CantInviteToPfpVacancy]: 'negotiations.changeTopic.errors.notification.cantInviteToPfpVacancy',
    default: 'negotiations.changeTopic.errors.defaultErrorText',
    networkError: 'negotiations.changeTopic.errors.networkErrorText',
    title: {
        [Error.ManagerLimit]: 'negotiations.changeTopic.errors.notification.title.MANAGER_LIMIT_EXCEED',
        [Error.EmployerLimit]: 'negotiations.changeTopic.errors.notification.title.EMPLOYER_LIMIT_EXCEED',
        [Error.NoFaService]: 'negotiations.changeTopic.errors.notification.title.NO_FA_SERVICE',
        [Error.CantInviteToPfpVacancy]: 'negotiations.changeTopic.errors.notification.title.cantInviteToPfpVacancy',
    },
    linkToPendingOrders: 'negotiations.changeTopic.errors.NO_FA_SERVICE.linkToPendingOrders',
    linkToPrice: 'negotiations.changeTopic.errors.NO_FA_SERVICE.linkToPrice',
    linkToFunnelSettings: 'negotiations.changeTopic.errors.notification.addressUnavailable.link',
};

export interface ChangeTopicErrorProps {
    errorCode: Exclude<Error, Error.NoFaService> | string;
}

const ChangeTopicError: TranslatedComponent<ChangeTopicErrorProps> = ({ trls, errorCode }) => {
    const titleKey = TrlKeys.title[errorCode as keyof typeof TrlKeys.title];
    const textKey = isChangeTopicActionError(errorCode) ? TrlKeys[errorCode] : TrlKeys.default;
    return (
        <>
            {titleKey && <NotificationHeading>{formatNewLine(trls[titleKey])}</NotificationHeading>}
            {formatNewLine(trls[textKey])}
        </>
    );
};

export const changeTopicError = {
    Element: translation(ChangeTopicError),
    kind: 'error',
};

const ChangeTopicErrorNoFa: TranslatedComponent = ({ trls }) => {
    return (
        <>
            <NotificationHeading>{trls[TrlKeys.title[Error.NoFaService]]}</NotificationHeading>
            {formatNewLine(trls[TrlKeys[Error.NoFaService]])}{' '}
            <SPALink to={'/employer/carts'}>{trls[TrlKeys.linkToPendingOrders]}</SPALink>
            <VSpacing base={4} />
            <Button Element={SPALink} to={'/price'} scale={ButtonScale.Small}>
                {trls[TrlKeys.linkToPrice]}
            </Button>
        </>
    );
};

export const changeTopicErrorNoQa = {
    Element: translation(ChangeTopicErrorNoFa),
    kind: 'error',
};

interface Props {
    vacancyId: string | number;
}

const ChangeTopicErrorBadAddrress: TranslatedComponent<Props> = ({ vacancyId, trls }) => {
    return (
        <>
            {formatNewLine(trls[TrlKeys[Error.AddressUnavailable]])}
            <VSpacing base={4} />
            <Button
                Element={SPALink}
                to={`/employer/vacancyresponses/funnel?vacancyId=${vacancyId}`}
                scale={ButtonScale.Small}
            >
                {trls[TrlKeys.linkToFunnelSettings]}
            </Button>
        </>
    );
};

export const changeTopicErrorBadAddrress = {
    Element: translation(ChangeTopicErrorBadAddrress),
    kind: 'error',
};
